"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  graphicsEditorContainer: {
    backgroundColor: '#fff',
    backgroundImage: 'linear-gradient(45deg,#efefef 25%,transparent 25%,transparent 75%,#efefef 75%,#efefef), linear-gradient(45deg,#efefef 25%,transparent 25%,transparent 75%,#efefef 75%,#efefef)',
    backgroundPosition: '0 0, 10px 10px',
    backgroundSize: '21px 21px',
    position: 'relative',
    overflow: 'auto',
    fontSize: 0,
    maxWidth: '100%',
    maxHeight: '100%',
    '&.fillContainer': {
      width: '100%',
      height: '100%'
    }
  }
};